import { StyleSheet } from '@react-pdf/renderer'

export const pdfStyles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'column',
    padding: 10,
    fontSize: 12,
    fontFamily: 'NotoSans',
  },

  title: { fontSize: 14, fontWeight: 'bold', textAlign: 'center', marginBottom: 10 },
  subtitle: { fontSize: 12, fontWeight: 'bold', textAlign: 'center', marginBottom: 5 },
  date: { fontSize: 10, textAlign: 'right', marginBottom: 10 },

  table: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: 4,
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 0,
    margin: 0,
  },
  tableHeader: {
    display: 'flex',
    width: '5%',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    borderStyle: 'solid',
    borderWidth: 1,
    backgroundColor: '#d3d3d3',
    padding: 5,
    textAlign: 'center',
    fontSize: 8,
  },
  tableColumn: {
    borderStyle: 'solid',
    borderWidth: 1,
    padding: 5,
    marginBottom: 3,
    fontSize: 8,
  },
  tableColumnTitle: {
    width: '20%',
    fontWeight: 'bold',
  },

  footer: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20,
    fontSize: 10,
    textAlign: 'justify',
    border: '1 solid #000',
    padding: 10,
  },
  signature: { marginTop: 20, fontSize: 10 },

  containerTableColumn: {
    textAlign: 'center',
    width: '5%',
  },
})
